// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8Xy0V","icon":"styles_icon__32jqf"};